export default {
  company(state) {
    return state.company;
  }
};
